export function initMenu() {
  const menuToggle = document.querySelector("[data-menu-toggle]")
  const menu = document.querySelector(".header")
  const menuContent = document.querySelector(".header-content")
  const mediaQuery = matchMedia("(min-width: 1440px)")

  if (menuToggle) {
    if (!mediaQuery.matches) {
      closeMenu()
    }

    menuToggle.addEventListener("click", (_e) => {
      const menuToggleExpanded = menuToggle.getAttribute("aria-expanded")
      if (menuToggleExpanded === "false") {
        openMenu()
      } else {
        closeMenu()
      }
    })

    menu.addEventListener("transitionend", () => transitionEndHandler(menu))

    function transitionEndHandler(menu) {
      if (menu.getAttribute("aria-hidden") === "true") {
        menuContent.hidden = true
      }
    }

    document.body.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeMenu()
      }
    })

    function openMenu() {
      menuContent.hidden = false
      menuToggle.setAttribute("aria-expanded", "true")
      menu.setAttribute("aria-hidden", "false")
      document.body.classList.add("offcanvas")
    }

    function closeMenu() {
      menu.setAttribute("aria-hidden", "true")
      menuToggle.setAttribute("aria-expanded", "false")
      document.body.classList.remove("offcanvas")
    }
  }

  /* prevent transitions on page load */
  setTimeout(() => {
    document.body.classList.remove("no-init-transitions")
  }, 1000)
}
